import moment from "moment-timezone";

export default {
    name: 'logFilter',
    namespaced: true,
    state: {
        filtro: {
            show: false,
            user: null,
            veus_id: null,
            event: null,
            model: null,
            model_id: null,
            start_date: moment().subtract(0, 'minutes').startOf('day').format(),
            end_date: moment().subtract(0, 'minutes').endOf('day').format()
        }
    },
    getters: {
        all (state) {
            return state.filtro
        },
        getSpecific (state, key) {
            return state.filtro[key]
        },
    },
    mutations: {
        setAll (state, obj) {
            state.filtro = obj
        },
        setSpecific (state, obj) {
            state.filtro = {...state.filtro, ...obj}
        },
    },
    actions: {
        setFiltro ({ commit, state }, obj) {
            commit('setAll', obj)
        },
        setSpecific ({ commit, state }, obj) {
            commit('setSpecific', obj)
        },
        reset ({ commit, state }) {
            commit('setSpecific', {
                show: false,
                user: null,
                veus_id: null,
                event: null,
                model: null,
                model_id: null,
                start_date: moment().subtract(0, 'minutes').startOf('day').format(),
                end_date: moment().subtract(0, 'minutes').endOf('day').format()
            })
        },
    }
}
